var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShirtStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M47.836 28.1119L53.9983 20.1997L39.5987 9C39.2149 10.1035 38.654 11.0286 37.9879 11.801C35.5634 14.6121 31.7453 15.3998 29.999 15.3998C26.5033 15.3998 23.7899 13.5731 22.1238 11.7126C21.2437 10.7297 20.6558 9.7374 20.3993 9L5.99976 20.1997L12.1756 28.1034L17.1994 24.1995V30.5097L19.203 36.7347H20.3993V17.6605L12.7321 23.6185L10.4958 20.7566L19.5934 13.6807C20.1415 14.3114 20.7664 14.9224 21.455 15.4824C23.5312 17.171 26.4367 18.5997 29.999 18.5997C31.5831 18.5997 34.0363 18.1752 36.4094 16.9756C37.8335 16.2557 39.2993 15.217 40.5165 13.7677L49.5062 20.7597L47.275 23.6245L39.5987 17.6626V44.1989H22.6272L21.8007 44.8052L22.6355 47.3988H42.7986V24.1995L47.836 28.1119Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.1318 33.4805L17.7077 38.3768H22.8077C23.9605 38.3768 24.4398 39.8659 23.5072 40.55L19.3812 43.5761L20.9572 48.4724C21.3134 49.5792 20.0586 50.4995 19.1259 49.8155L15 46.7894L10.874 49.8155C9.94143 50.4995 8.68656 49.5792 9.0428 48.4724L10.6188 43.5761L6.49282 40.55C5.56021 39.866 6.03947 38.3768 7.19229 38.3768H12.2923L13.8682 33.4805C14.2245 32.3737 15.7755 32.3737 16.1318 33.4805Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M34.7865 28.1996C34.7865 30.8419 32.6445 32.984 30.0021 32.984C27.3598 32.984 25.2178 30.8419 25.2178 28.1996C25.2178 25.5573 27.3598 23.4152 30.0021 23.4152C32.6445 23.4152 34.7865 25.5573 34.7865 28.1996Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShirtStar);
export default __webpack_public_path__ + "static/media/shirt-star.5d7d1d8d.svg";
export { ForwardRef as ReactComponent };